/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';
import { MaterialIcon } from '@blend/enterprise-components';
import { PopoverList } from '../../common/PopoverList/PopoverList';

export namespace PopoverMenu {
  export interface Props {
    menuItems: MenuItem[];
    iconType: MaterialIcon.Props['type'];
  }
}

interface MenuItem {
  name: string;
  display: string;
  onClick: () => void;
}

const styles = StyleSheet.create({
  button: {
    border: 'none',
    background: 'none',
    boxShadow: 'none',
    ...mixins.padding(4, 0, 0, 0),
  },
});

export const PopoverMenu: React.FC<PopoverMenu.Props> = ({ iconType, menuItems }) => {
  return menuItems.length ? (
    <PopoverList anchorPosition={'right-end'} buttonConfigs={menuItems}>
      <button data-it="PopoverMenu-Button" className={css(styles.button)}>
        <MaterialIcon type={iconType} size={16} color={colors.catalystLight40} />
      </button>
    </PopoverList>
  ) : null;
};
